<div class="container" *ngIf="!openViewList">
  <!-- Header Row -->
  <mat-dialog-actions class="w-100">
    <div class="header-row phi-flex-center phi-justify-content-between phi-gap-12 w-100">
      <h4 class="pl-5">All Video List</h4>
      <!-- Close Button -->
      <!-- <div class="popup-close"> -->
      <span [mat-dialog-close] class="fs-24 material-icons popup-close-icon">close</span>
      <!-- </div> -->
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons" *ngIf="loggedInUserRole == 'Super Admin'">
      <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content" [style.background-color]="buttonColorName" (click)="showVideo()">
        <span class="material-icons fs-20 mr-5">add</span>
        VIDEO LIST
      </button>

      <button type="button" class="add_btn fs-14 fs_12ForMobile float-right center-content" [style.background-color]="buttonColorName" (click)="createVideo(null)" *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD'">
        <span class="material-icons fs-20 mr-5">add</span>
        CREATE VIDEO
      </button>
    </div>
  </mat-dialog-actions>

  <!-- Table -->
  <mat-dialog-content>
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
        <!-- Sr. No -->
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="srNo" style="min-width: 80px !important;">Sr. No</th>
          <td mat-cell *matCellDef="let row">{{ row.srNo }}</td>
        </ng-container>

        <!-- Title -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="title">Title</th>
          <td mat-cell *matCellDef="let row">
            <textarea class="edittextarea w-100 mat-height40 mat-input-style mt-5" [(ngModel)]="row.title" maxlength="255" readonly rows="3" cols="32"></textarea>
          </td>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="description">Description</th>
          <td mat-cell *matCellDef="let row">
            <textarea class="edittextarea w-100 mat-height40 mat-input-style mt-5" [(ngModel)]="row.description" maxlength="255" readonly rows="3" cols="32"></textarea>
          </td>
        </ng-container>

        <!-- Attachment -->
        <ng-container matColumnDef="attachment">
          <th mat-header-cell *matHeaderCellDef style="min-width: 80px !important;">Attachment</th>
          <td mat-cell *matCellDef="let row">
            <img src="././assets/icon/VideosIcon.svg" style="cursor: pointer;" alt="" (click)="openVideo(row.url)" width="30px" />
          </td>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef style="min-width: 80px !important;">Action</th>
          <td mat-cell *matCellDef="let row">
            <div class="phi-flex-center phi-gap-12 phi-justify-content-center">
              <button color="primary" (click)="editVideo(row)" class="p-0 action-btn" [disabled]="loggedInUserRole !== 'Super Admin'">
                <!-- <img class="cp imgdelete" title="Edit" src="././assets/icon/edit.png" width="25px"> -->
                <mat-icon class="material-symbols-outlined yellow">edit_square</mat-icon>
              </button>
              <button color="red" (click)="deleteVideo(row.id)" class="p-0 action-btn" [disabled]="loggedInUserRole !== 'Super Admin'">
                <!-- <span class="material-icons fs-20 red cp">delete</span> -->
                <mat-icon class="material-icons red-cl">delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Header & Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <!-- Pagination -->
      <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons class="phi-mat-pagination"></mat-paginator>
    </div>
  </mat-dialog-content>
</div>
